import { LOGO_URL } from '@constants/Validation';
import { Trans } from '@lingui/macro';
import { Box, Button, Typography } from '@material-ui/core';
import { useAuth } from '@swyft/auth';
import React from 'react';

export const AccessDeniedErrorPage = () => {
  const { signOut } = useAuth();

  return (
    <Box width='100vw' height='100vh' className='flex justify-center items-center bg-white'>
      <Box width={{ xs: 400, md: 500 }} className='shadow-xl p-16 border rounded'>
        <img src={LOGO_URL} alt='logo-pinelyne' className='mx-auto h-12' />
        <Typography variant='h5' className='text-center my-6'>
          <Trans>Access Denied</Trans>
        </Typography>
        <Typography variant='subtitle2' className='text-center'>
          <Trans>You do not have permission to access the requested resource.</Trans>
        </Typography>
        <Button
          color='primary'
          variant='contained'
          className='normal-case font-normal w-40 h-12 shadow-none my-8 block mx-auto'
          onClick={signOut}
        >
          <Trans>Sign Out</Trans>
        </Button>
      </Box>
    </Box>
  );
};
